module.exports = __webpack_public_path__ + "img/infographic_nyc.36189421.jpg";